import { Button, Grid, InputAdornment, TextField, Typography, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import axios from "../../../axios/AxiosInterceptors";
import { onError } from "../../../store/actions/popupActions";
import TransactionComments from "./TransactionComments";
import TransactionEvents from "./TransactionEvents";

const useStyles = makeStyles((theme) => ({
    offset: theme.mixins.toolbar,
    layout: {
        width: 'auto',
        marginTop: theme.spacing(10),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
            width: 1200,
            marginLeft: 'auto',
            marginRight: 'auto',
        }
    },
    paper: {
        width: 'auto',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(5),
    },
    table: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    tableRow: {
        "&:hover": {
            cursor: 'pointer'
        }
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    }
}));

const CapModTransaction = (props) => {

    const classes = useStyles(props);
    const dispatch = useDispatch();
    const params = useParams();
    const history = useHistory();
    const [transaction, setTransaction] = useState();

    useEffect(() => {
        retrieveCapModTransaction();
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const retrieveCapModTransaction = async () => {
        await trackPromise(axios.get("/capacity/account/" + params.accountId + "/transactions/capmod/" + params.transactionId).then(response => {
            setTransaction(response.data);
        }).catch(error => {
            dispatch(onError(error));
        }));
    }

    return (
        <main className={classes.layout}>
            {transaction &&
                <React.Fragment>
                    <Typography variant="h5" align="center" style={{ marginBottom: 50 }}>{transaction.companyName} CAPMOD Transaction {transaction.transactionId}</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={1} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.startDate} disabled={true} label="Start Date" fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={1} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.resourceName} disabled={true} label="Resource Name" fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={1} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.queueNumber ? transaction.queueNumber : ''} disabled={true} label="Queue Number" fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={2} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.capModType} disabled={true} label="Cap Mod Type" fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={2} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.status} disabled={true} label="Status" fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={2} />
                        <Grid item xs={6} sm={2} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.summerIncrease} disabled={true} label="Summer Increase" InputProps={{
                                endAdornment: <InputAdornment position="start">MWs</InputAdornment>,
                            }} fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={2} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.winterIncrease} disabled={true} label="Winter Increase" InputProps={{
                                endAdornment: <InputAdornment position="start">MWs</InputAdornment>,
                            }} fullWidth />
                        </Grid>
                    </Grid>
                    <TransactionEvents accountId={transaction.accountId} transactionType="capmod" transactionId={transaction.transactionId} />
                    <TransactionComments accountId={transaction.accountId} transactionType="capmod" transactionId={transaction.transactionId} />
                </React.Fragment>
            }
            <Grid container spacing={2}>
                <Grid item xs={6} sm={4} />
                <Grid item xs={6} sm={4}>
                    <Button fullWidth onClick={() => history.goBack()} style={{ marginTop: 50 }}>Back</Button>
                </Grid>
                <Grid item xs={6} sm={4} />
            </Grid>
        </main>
    )

}

export default CapModTransaction;